export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8727.a712a9cb.jpg";